import { FC } from 'react'

import { BookingTemplateRequestDialog, BookingTemplateRequestDialogProps } from './BookingTemplateRequestDialog'

export const BookingTemplateRequestDialogSwitch: FC<BookingTemplateRequestDialogProps & { isOpen: boolean }> = ({
  isOpen,
  ...props
}) => {
  if (isOpen) {
    return <BookingTemplateRequestDialog {...props} />
  }
  return null
}
